<template>
  <p class="rate-text">{{formatValue(rate)}} €</p>
  <p class="rate-sub-text">{{$store.getters.translations.initial_monthly_rate}}</p>
  <a :href="requestUrl" class="cta-button">{{$store.getters.translations.non_binding_request}}</a>
</template>

<script>
export default {
  name: 'Rate',
  props:[
      'rate',
      'amortizationRate',
      'interest',
      'sellingPrice',
      'additionalCosts',
      'netLoan',
      'equity',
      'currentSelectedYear'
  ],
  data(){
    return {
      requestUrl:''
    }
  },
  watch:{
    rate(){
      this.buildLink();
    }
  },
  methods:{
    formatValue(value) {
      value = Math.round(value)
      return value
          .toLocaleString('de-DE');
    },
    /**
     * Builds the request link
     **/
    buildLink(){
      this.requestUrl = document.getElementById('form-uri').value;
      this.requestUrl+=this.buildRequestData();
    },
    /**
     *
     * @return {string}
     */
    buildRequestData(){

      let requestData = "?tx_powermail_pi1[field][tilgungsrate]=" + this.amortizationRate;
      requestData += "&tx_powermail_pi1[field][sollzinsbindung]=" + this.currentSelectedYear;
      requestData += "&tx_powermail_pi1[field][kaufpreis]=" + this.sellingPrice;
      requestData += "&tx_powermail_pi1[field][nebenkosten]=" + this.additionalCosts;
      requestData += "&tx_powermail_pi1[field][eigenkapital]=" + this.equity;
      requestData += "&tx_powermail_pi1[field][zins]=" + this.interest;
      requestData += "&tx_powermail_pi1[field][rate]=" + this.formatValue(this.rate);
      requestData += "&tx_powermail_pi1[field][nettodarlehen]=" + this.formatValue(this.netLoan);
      requestData += "&tx_ccmfinancecalculator_calculatorresult[result][amortizationRate]=" + this.amortizationRate;
      requestData += "&tx_ccmfinancecalculator_calculatorresult[result][interestDuration]=" + this.currentSelectedYear;
      requestData += "&tx_ccmfinancecalculator_calculatorresult[result][sellingPrice]=" + this.sellingPrice;
      requestData += "&tx_ccmfinancecalculator_calculatorresult[result][additionalCosts]=" + this.additionalCosts;
      requestData += "&tx_ccmfinancecalculator_calculatorresult[result][equity]=" + this.equity;
      requestData += "&tx_ccmfinancecalculator_calculatorresult[result][calculatedInterest]=" + this.interest;
      requestData += "&tx_ccmfinancecalculator_calculatorresult[result][rate]=" + this.formatValue(this.rate);
      requestData += "&tx_ccmfinancecalculator_calculatorresult[result][netLoan]=" + this.formatValue(this.netLoan);

      return requestData;
    }



  },

  beforeMount() {

  }
}
</script>

<style scoped>

</style>
